<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<li>
		<template
				v-if="method.type === 'financial_aid'
					&& (only === null || only['type'] === 'financial_aid')
					&& (without === null || without['type'] !== 'financial_aid')"
		>
			<div class="cops-fin-aid">
				<v-layout row align-center ma-0>
					<v-flex xs11 pa-0>
						<v-checkbox
								v-model="payments.financial_aid.selected"
								hide-details
								class="my-3"
								:disabled="!method.enabled"

								@change="onFinAidSelected(payments.financial_aid)"
								v-bind="ADAattr('label', (`${$globs['financial_aid_information']['payment_voucher_label_apply']
								? $globs['financial_aid_information']['payment_voucher_label_apply']
								: 'Apply Book Voucher to this order'}`) + ', balance: ' + formatPrice(payments.financial_aid.balance))"
						>
							<template v-slot:label="">
								<div>
									<span v-if="$globs['financial_aid_information']['payment_voucher_label_apply']">{{ $globs['financial_aid_information']['payment_voucher_label_apply'] }}</span>
									<span v-else>Apply <strong>Book Voucher</strong> to this order</span>
									(Balance: <strong>${{ formatPrice(payments.financial_aid.balance) }}</strong>)
								</div>
							</template>
						</v-checkbox>
					</v-flex>

					<v-flex xs1 pa-0>
						<div>
							<v-btn
									flat
									icon
									color="#2170f2"
									class="my-0"
									v-bind="ADAattr('label', 'Apply')"
									@click.stop="updateFinAid"
							>
								<v-icon v-bind:class="{'spin-icon' : updating_fin_aid}">cached</v-icon>
							</v-btn>
						</div>
					</v-flex>
				</v-layout>

				<v-divider v-if="!noDivider" v-bind="ADAattr('hidden')"></v-divider>
			</div>
		</template>

		<template
				v-if="method.type === 'gift_certificates'"
		>
			<div class="cops-gc" v-for="(gift, gift_index) in payments.gift_certificates.options">
				<template
						v-if="(only === null || only['method']['id'] === gift['id'])
							&& (without === null || without['method']['id'] !== gift['id'])"
				>
					<v-checkbox
							v-model="gift.selected"
							hide-details class="my-3"
							:disabled="!gift.enabled"
							v-bind="ADAattr('label', ADAcustomizeCertificateLabel(gift.type, gift.type_full, gift.name, formatPrice(gift.balance), $globs['hide_voucher_balance'], $globs['institute_id']))"

							@change="onGCSelected(gift)"
					>
						<template v-slot:label="">
							<div v-html="customizeCertificateLabel(gift.type, gift.type_full, gift.name, formatPrice(gift.balance), $globs['hide_voucher_balance'], $globs['institute_id'])"></div>
						</template>
					</v-checkbox>

					<v-divider v-if="!noDivider" v-bind="ADAattr('hidden')"></v-divider>
				</template>
			</div>
		</template>
	</li>
</template>

<script>
	import StudentCardForm from './StudentCardForm';
	import {formatPrice} from './../includes/Miscellaneous';
	import {customizeCertificateLabel} from './../includes/SpecialCasesHandles';
	import Axios from 'axios';
	import {EventBus} from './../includes/EventBus';

	export default {
		name: "SinglePaymentMethod",

		components: {
			StudentCardForm,
		},

		props: {
			method: {
				type: Object,
				default: null,
			},
			payments: {
				type: Object,
				default: null,
			},
			noDivider: {
				type: Boolean,
				default: false,
			},
			only: {
				type: Object,
				default: null,
			},
			without: {
				type: Object,
				default: null,
			},
		},

		data() {
			return {
				updating_fin_aid: false,
			};
		},

		created() {
			if(this.$globs['checkout_preferences']['payment'] === 'gc' && this.method.type === 'gift_certificates') {
				let gc_preselected = false;
				_.map(this.payments.gift_certificates.options, gc => {
					if(gc.type === 'voucher' && !gc.has_restrictions && gc.enabled && !gc_preselected && gc.balance > 0) {
						gc.selected = true;
						gc_preselected = true;
						this.onGCSelected(gc);
					}
					return gc;
				});
			}
		},

		watch: {
			payments: {
				deep: true,

				handler: function (value) {
					const self = this;

					if (self.method.type === 'gift_certificates') {
						_.forEach(self.payments.gift_certificates.options, (opt) => {
							if (opt.processed) return;

							if (opt.selected) {
								self.onGCSelected(opt);
							}
							opt.processed = true;
						});
					}
				},
			},
		},

		methods: {
			formatPrice,
			customizeCertificateLabel,

			onBraintreeSubmit(payload) {
				this.$emit('submitted-braintree', payload);
			},

			onStudentCardSubmit(payload) {
				this.$emit('submitted-student-card', payload);
			},

			onFinAidSelected(fin_aid) {
				this.$emit('selected', {type: 'financial_aid', method: fin_aid});
			},

			onGCSelected(gc) {
				this.$emit('selected', {type: 'gift_certificate', method: gc});

				if (typeof sendGAAction === 'function') {
					sendGAAction('Checkout: toggle using GC');
				}
			},

			updateFinAid() {
				const self = this;

				if (self.updating_fin_aid) {
					return;
				}

				self.updating_fin_aid = true;

				Axios.get('/sc/rest/index.php/check_financial_aid').then(({data}) => {
					self.updating_fin_aid = false;

					if (data['error']) {
						EventBus.$emit('show-message', {
							msg: data['error'],
							severity: 2,
						});
						self.$emit('updated-financial-aid', null);

						return;
					}

					self.$emit('updated-financial-aid', data);
				});
			},
		},
	};
</script>

<style scoped lang="less">
	.spin-icon {
		animation: loader 1s infinite;
		display: flex;
	}

	@-moz-keyframes loader {
		from {
			transform: rotate(0);
		}
		to {
			transform: rotate(-360deg);
		}
	}

	@-webkit-keyframes loader {
		from {
			transform: rotate(0);
		}
		to {
			transform: rotate(-360deg);
		}
	}

	@-o-keyframes loader {
		from {
			transform: rotate(0);
		}
		to {
			transform: rotate(-360deg);
		}
	}

	@keyframes loader {
		from {
			transform: rotate(0);
		}
		to {
			transform: rotate(-360deg);
		}
	}

	.cops-fin-aid {

	}
</style>
